module.exports = __webpack_public_path__ + "img/logo_miss2019.ede98b0c.jpg";